// @ts-nocheck

/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { VePERP, VePERPInterface } from "../VePERP";

const _abi = [
  {
    name: "CommitOwnership",
    inputs: [
      {
        name: "admin",
        type: "address",
        indexed: false,
      },
    ],
    anonymous: false,
    type: "event",
  },
  {
    name: "ApplyOwnership",
    inputs: [
      {
        name: "admin",
        type: "address",
        indexed: false,
      },
    ],
    anonymous: false,
    type: "event",
  },
  {
    name: "Deposit",
    inputs: [
      {
        name: "provider",
        type: "address",
        indexed: true,
      },
      {
        name: "value",
        type: "uint256",
        indexed: false,
      },
      {
        name: "locktime",
        type: "uint256",
        indexed: true,
      },
      {
        name: "type",
        type: "int128",
        indexed: false,
      },
      {
        name: "ts",
        type: "uint256",
        indexed: false,
      },
    ],
    anonymous: false,
    type: "event",
  },
  {
    name: "Withdraw",
    inputs: [
      {
        name: "provider",
        type: "address",
        indexed: true,
      },
      {
        name: "value",
        type: "uint256",
        indexed: false,
      },
      {
        name: "ts",
        type: "uint256",
        indexed: false,
      },
    ],
    anonymous: false,
    type: "event",
  },
  {
    name: "Supply",
    inputs: [
      {
        name: "prevSupply",
        type: "uint256",
        indexed: false,
      },
      {
        name: "supply",
        type: "uint256",
        indexed: false,
      },
    ],
    anonymous: false,
    type: "event",
  },
  {
    name: "SmartWalletCheckerComitted",
    inputs: [
      {
        name: "future_smart_wallet_checker",
        type: "address",
        indexed: false,
      },
    ],
    anonymous: false,
    type: "event",
  },
  {
    name: "SmartWalletCheckerApplied",
    inputs: [
      {
        name: "smart_wallet_checker",
        type: "address",
        indexed: false,
      },
    ],
    anonymous: false,
    type: "event",
  },
  {
    name: "EmergencyUnlockToggled",
    inputs: [
      {
        name: "emergencyUnlockActive",
        type: "bool",
        indexed: false,
      },
    ],
    anonymous: false,
    type: "event",
  },
  {
    stateMutability: "nonpayable",
    type: "constructor",
    inputs: [
      {
        name: "token_addr",
        type: "address",
      },
      {
        name: "_name",
        type: "string",
      },
      {
        name: "_symbol",
        type: "string",
      },
      {
        name: "_version",
        type: "string",
      },
    ],
    outputs: [],
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "commit_transfer_ownership",
    inputs: [
      {
        name: "addr",
        type: "address",
      },
    ],
    outputs: [],
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "apply_transfer_ownership",
    inputs: [],
    outputs: [],
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "commit_smart_wallet_checker",
    inputs: [
      {
        name: "addr",
        type: "address",
      },
    ],
    outputs: [],
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "apply_smart_wallet_checker",
    inputs: [],
    outputs: [],
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "toggleEmergencyUnlock",
    inputs: [],
    outputs: [],
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "recoverERC20",
    inputs: [
      {
        name: "token_addr",
        type: "address",
      },
      {
        name: "amount",
        type: "uint256",
      },
    ],
    outputs: [],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "get_last_user_slope",
    inputs: [
      {
        name: "addr",
        type: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "int128",
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "user_point_history__ts",
    inputs: [
      {
        name: "_addr",
        type: "address",
      },
      {
        name: "_idx",
        type: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "locked__end",
    inputs: [
      {
        name: "_addr",
        type: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
      },
    ],
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "checkpoint",
    inputs: [],
    outputs: [],
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "deposit_for",
    inputs: [
      {
        name: "_addr",
        type: "address",
      },
      {
        name: "_value",
        type: "uint256",
      },
    ],
    outputs: [],
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "create_lock",
    inputs: [
      {
        name: "_value",
        type: "uint256",
      },
      {
        name: "_unlock_time",
        type: "uint256",
      },
    ],
    outputs: [],
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "increase_amount",
    inputs: [
      {
        name: "_value",
        type: "uint256",
      },
    ],
    outputs: [],
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "increase_unlock_time",
    inputs: [
      {
        name: "_unlock_time",
        type: "uint256",
      },
    ],
    outputs: [],
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "withdraw",
    inputs: [],
    outputs: [],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "balanceOf",
    inputs: [
      {
        name: "addr",
        type: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "balanceOf",
    inputs: [
      {
        name: "addr",
        type: "address",
      },
      {
        name: "_t",
        type: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "balanceOfWeighted",
    inputs: [
      {
        name: "addr",
        type: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "balanceOfWeighted",
    inputs: [
      {
        name: "addr",
        type: "address",
      },
      {
        name: "_t",
        type: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "balanceOfAt",
    inputs: [
      {
        name: "addr",
        type: "address",
      },
      {
        name: "_block",
        type: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "balanceOfAt",
    inputs: [
      {
        name: "addr",
        type: "address",
      },
      {
        name: "_block",
        type: "uint256",
      },
      {
        name: "weighted",
        type: "bool",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "totalSupply",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "totalSupply",
    inputs: [
      {
        name: "t",
        type: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "totalSupplyWeighted",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "totalSupplyWeighted",
    inputs: [
      {
        name: "t",
        type: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "totalSupplyAt",
    inputs: [
      {
        name: "_block",
        type: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "totalSupplyAt",
    inputs: [
      {
        name: "_block",
        type: "uint256",
      },
      {
        name: "weighted",
        type: "bool",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "totalPERPSupply",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "totalPERPSupplyAt",
    inputs: [
      {
        name: "_block",
        type: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "token",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "supply",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "locked",
    inputs: [
      {
        name: "arg0",
        type: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "tuple",
        components: [
          {
            name: "amount",
            type: "int128",
          },
          {
            name: "end",
            type: "uint256",
          },
        ],
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "epoch",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "point_history",
    inputs: [
      {
        name: "arg0",
        type: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "tuple",
        components: [
          {
            name: "bias",
            type: "int128",
          },
          {
            name: "slope",
            type: "int128",
          },
          {
            name: "ts",
            type: "uint256",
          },
          {
            name: "blk",
            type: "uint256",
          },
          {
            name: "perp_amt",
            type: "uint256",
          },
        ],
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "user_point_history",
    inputs: [
      {
        name: "arg0",
        type: "address",
      },
      {
        name: "arg1",
        type: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "tuple",
        components: [
          {
            name: "bias",
            type: "int128",
          },
          {
            name: "slope",
            type: "int128",
          },
          {
            name: "ts",
            type: "uint256",
          },
          {
            name: "blk",
            type: "uint256",
          },
          {
            name: "perp_amt",
            type: "uint256",
          },
        ],
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "user_point_epoch",
    inputs: [
      {
        name: "arg0",
        type: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "slope_changes",
    inputs: [
      {
        name: "arg0",
        type: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "int128",
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "emergencyUnlockActive",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "bool",
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "name",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "string",
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "symbol",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "string",
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "version",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "string",
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "decimals",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "future_smart_wallet_checker",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "smart_wallet_checker",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "admin",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
      },
    ],
  },
  {
    stateMutability: "view",
    type: "function",
    name: "future_admin",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
      },
    ],
  },
];

const _bytecode =
  "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";

export class VePERP__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    token_addr: string,
    _name: string,
    _symbol: string,
    _version: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<VePERP> {
    return super.deploy(
      token_addr,
      _name,
      _symbol,
      _version,
      overrides || {}
    ) as Promise<VePERP>;
  }
  getDeployTransaction(
    token_addr: string,
    _name: string,
    _symbol: string,
    _version: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      token_addr,
      _name,
      _symbol,
      _version,
      overrides || {}
    );
  }
  attach(address: string): VePERP {
    return super.attach(address) as VePERP;
  }
  connect(signer: Signer): VePERP__factory {
    return super.connect(signer) as VePERP__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): VePERPInterface {
    return new utils.Interface(_abi) as VePERPInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): VePERP {
    return new Contract(address, _abi, signerOrProvider) as VePERP;
  }
}
